import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../auth/auth.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (this.auth.isLogged()) {
        // Check user roles
        if (route.component && 'isGranted' in route.component) {
          const isGranted: string[] = <string[]>route.component.isGranted;

          // No roles specified => accept all
          if (isGranted.length === 0) {
            observer.next(true);
            return;
          }

          // Check roles
          this.auth.hasRoles(isGranted).subscribe((hasRoles) => {
            observer.next(hasRoles);
          });
          return;
        }

        observer.next(true);
        return;
      }

      let redirectUrl = '/login';
      if (state.url.length) {
        redirectUrl += '?redirect=' + encodeURIComponent(state.url);
      }

      this.router.navigateByUrl(redirectUrl).then();

      observer.next(true);
      return;
    });
  }
}
